export default function Loading() {
  return <div className='animate-pulse bg-neutral100 blur-md'></div>
}
